import { useRouter } from 'next/router'
import { useSelector, useDispatch } from 'react-redux'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'

import { genPathByNavData } from 'utils/api'
import { setPreselectVender, setNavigateInfo } from 'store/cache/cacheSlice'

const Controls = ({ album, closeModal }) => {
  const router = useRouter()
  const dispatch = useDispatch()
  const onReserveClick = async () => {
    dispatch(setNavigateInfo({ id: album._id, type: 'Album' }))
    if (!!album?.navData?.page) {
      const { path, isExternalLink } = await genPathByNavData(album.navData)
      if (path) {
        if (isExternalLink) {
          window.open(path, '_blank')
        } else {
          if (/^\/service\//.test(path)) {
            dispatch(setPreselectVender(album.vender?._id || null))
          }
          if (closeModal) closeModal()
          router.push(path)
        }
      }
    } else {
      if (closeModal) closeModal()
      router.push('/')
    }
  }

  const onConsultClick = () => {
    window.open('https://page.line.me/tyf8206o?openQrModal=true', '_blank')
  }

  return (
    <Box m={{ xs: 5, lg: 0 }}>
      <Grid container spacing={2} direction="row">
        <Grid item xs={6}>
          <Button
            id="consult"
            className="action"
            variant="outlined"
            fullWidth
            onClick={onConsultClick}
          >
            免費諮詢
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button
            id="book"
            className="action"
            variant="contained"
            color="primary"
            fullWidth
            onClick={onReserveClick}
          >
            {album?.displayGotoReservation || '前往預約'}
          </Button>
        </Grid>
      </Grid>
    </Box>
  )
}

export default Controls
